module.exports = __webpack_public_path__ + "static/media/sales-order-slide-12.dbf88b1a.jpg";